export default __webpack_public_path__ + "static/media/exceed.3a77358b.svg";